import { __decorate } from "tslib";
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import HelixElement from '../../shared/types/helix-element.js';
import { classMap } from 'lit/directives/class-map.js';
import '../icon/icon.js';
import { consume } from '@lit/context';
import { accordionInvertedContext } from './accordion-context.js';
import { SlotController } from '../../shared/controllers/slot.controller.js';
import { accordionItemStyles } from './accordion-item.styles.js';
import { componentStyles } from '../../shared/styles/component.styles.js';
let HlxAccordionItem = class HlxAccordionItem extends HelixElement {
    constructor() {
        super(...arguments);
        this.slotController = new SlotController(this, 'title', 'panel', 'icon');
        this.expanded = false;
        this.chevronLocation = 'prefix';
        this.disabled = false;
        this.spacing = 'condensed';
        this.inverted = false;
    }
    render() {
        return html `
            <div
                class="${classMap({
            'hlx-accordion-item': true,
            'hlx-accordion-item-disabled': this.disabled,
            'hlx-accordion-item-inverted': this.inverted,
        })}">
                <button
                    class="${classMap({
            'hlx-button-reset': true,
            'hlx-accordion-item-title': true,
            'hlx-accordion-item-title-inverted': this.inverted,
            'hlx-accordion-item-title-disabled': this.disabled,
            'hlx-accordion-item-title-spaced': this.spacing === 'spaced',
        })}"
                    ?disabled=${this.disabled}
                    @click=${this.handleClick}>
                    <div
                        class="${classMap({
            'hlx-accordion-item-chevron-hidden': this.chevronLocation === 'suffix',
            'hlx-accordion-item-chevron-prefix': this.chevronLocation === 'prefix',
        })}">
                        <div
                            class="${classMap({
            'hlx-accordion-item-chevron': !this.inverted && !this.disabled,
            'hlx-accordion-item-chevron-open': this.expanded,
        })}">
                            <hlx-icon name="chevron-down" size="14" title="Expand icon" />
                        </div>
                    </div>
                    <div
                        class="${classMap({
            'hlx-accordion-icon-slot': this.slotController.hasSlot('icon'),
        })}">
                        <slot name="icon"></slot>
                    </div>
                    <div
                        class="${classMap({
            'hlx-accordion-item-with-suffix-chevron': this.chevronLocation === 'suffix',
        })}">
                        <div
                            class="${classMap({
            'hlx-accordion-title-text': true,
            'hlx-accordion-title-text-spaced': this.spacing === 'spaced',
        })}">
                            <slot name="title"></slot>
                        </div>
                        <div
                            class="${classMap({
            'hlx-accordion-item-chevron-hidden': this.chevronLocation === 'prefix',
            'hlx-accordion-item-chevron-suffix': this.chevronLocation === 'suffix',
        })}">
                            <div
                                class="${classMap({
            'hlx-accordion-item-chevron': !this.inverted && !this.disabled,
            'hlx-accordion-item-chevron-open': this.expanded,
        })}">
                                <hlx-icon name="chevron-down" size="14" title="Expand icon" />
                            </div>
                        </div>
                    </div>
                </button>
                <div
                    aria-hidden=${this.expanded ? 'false' : 'true'}
                    class="${classMap({
            'hlx-accordion-item-panel': true,
            'hlx-animation-with-prefers-reduced-motion': true,
            'hlx-accordion-item-panel-with-prefix-chevron': this.chevronLocation === 'prefix',
            'hlx-accordion-item-panel-with-suffix-chevron': this.chevronLocation === 'suffix',
            'hlx-accordion-item-panel-expanded': this.expanded,
            'hlx-accordion-item-panel-spaced': this.spacing === 'spaced',
            'hlx-accordion-item-panel-condensed': this.spacing === 'condensed',
        })}">
                    <div
                        class="${classMap({
            'hlx-accordion-item-panel-inner': true,
            'hlx-accordion-panel-text': true,
            'hlx-accordion-panel-text-inverted': this.inverted,
        })}">
                        <slot name="panel"></slot>
                    </div>
                </div>
                <div class="hlx-accordion-item-divider"></div>
            </div>
        `;
    }
    handleClick() {
        this.expanded = !this.expanded;
        this.emit('hlx-click', undefined, { bubbles: true });
    }
};
HlxAccordionItem.styles = [componentStyles, accordionItemStyles];
__decorate([
    property({ type: Boolean, reflect: true })
], HlxAccordionItem.prototype, "expanded", void 0);
__decorate([
    property({ type: String, attribute: 'chevron-location' })
], HlxAccordionItem.prototype, "chevronLocation", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], HlxAccordionItem.prototype, "disabled", void 0);
__decorate([
    property({ type: String, attribute: 'spacing' })
], HlxAccordionItem.prototype, "spacing", void 0);
__decorate([
    consume({ context: accordionInvertedContext, subscribe: true }),
    property({ type: Boolean, reflect: true })
], HlxAccordionItem.prototype, "inverted", void 0);
HlxAccordionItem = __decorate([
    customElement('hlx-accordion-item')
], HlxAccordionItem);
export { HlxAccordionItem };
//# sourceMappingURL=accordion-item.js.map